import { Box } from "@chakra-ui/react";

interface IProps {
  isActive: boolean;
  onClick: () => void;
}

const Bullet = ({ isActive, onClick }: IProps): JSX.Element => (
  <Box
    width="1rem"
    height="1rem"
    borderRadius="full"
    cursor="pointer"
    background={isActive ? "ud-primary" : "ud-grey-300"}
    onClick={onClick}
  />
);

export default Bullet;
